<template>
  <div class="xbb">
    <bonus-progress
      class="xbb_progress"
      v-bind="progressData"
      @open-dialog="openDialog"/>
    <div
      v-if="dialog.visible"
      class="flex items-center fullscreen xbb_dialog">
      <component
        :is="dialog.component"
        :limit-amount="bonusData.Active.LimitAmout"
        :break-amount="bonusData.Active.BreakAmout"
        :total-amount="bonusData.TotalAmount"
        :mission="bonusData.Mession"
        :adPic="bonusData.Ad && bonusData.Ad.AdPic"
        :adUrl="bonusData.Ad && bonusData.Ad.AdUrl"
        :status="bonusData.Status"
        @handle-continue-watch="handleContinueWatch"
        @close-dialog="closeDialog"/>
    </div>
    <count-time
      v-if="progressData.timer"
      :transform="(time) => Math.floor(time / 1000)"
      @tick="handleBonusTimer"></count-time>
  </div>
</template>

<script>
// https://github.com/pladaria/reconnecting-websocket#readme
import ReconnectingWebSocket from 'reconnecting-websocket'

import { mapState } from 'vuex'
import BonusProgress from './components/BonusProgress'
import BonusDialogBreak from './components/BonusDialogBreak'
import BonusDialogWait from './components/BonusDialogWait'
import BonusDialogFull from './components/BonusDialogFull'
import BonusDialogAd from './components/BonusDialogAd'
import CountTime from '@/components/CountTime.js'
import { isIOS } from '@/utils/index.js'
import { missionType } from './utils'

export default {
  name: 'Xbb',
  components: {
    BonusProgress,
    BonusDialogBreak,
    BonusDialogWait,
    BonusDialogFull,
    BonusDialogAd,
    CountTime
  },
  props: {
    player: {
      type: Object,
      default: null
    },
    playingEvent: {
      type: Function,
      default: () => {
        return () => { }
      }
    },
    pauseEvent: {
      type: Function,
      default: () => {
        return () => { }
      }
    },
    isDestroy: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      // WebSocket
      ws: null,
      socketId: null,
      // Dialog
      dialog: {
        visible: false,
        component: 'BonusDialogBreak'
      },
      // WAIT status 時需要判斷是否點擊`繼續看`，true 則不顯示彈窗
      continueWatch: false,
      // WebSocket 回傳資料
      bonusData: {
        Active: {
          LimitAmout: 0,
          BreakAmout: 0
        },
        Mession: null,
        TotalAmount: 0,
        Ad: {
          AdPic: null,
          AdUrl: null
        }
      },
      progressData: {
        status: 'PLAY',
        timer: false,
        progress: 0,
        times: 0,
        amount: 0
      },
      adVersion: false,
      firstAd: true,
      firstGetStatus: true,
      bonusStatus: 'OPEN',
      playEvent: 'PLAY',
      /*
      * AD 版本, 當進入頁面後 WAIT 顯示完廣告按播放, 需要彈出WAIT彈窗
      * 註: 由於對方ADSTART不會送 WAIT 所以只能多此判斷
      */
      firstAdWait: false,
      triggerOnceAdWait: true
    }
  },
  computed: {
    ...mapState({
      xbbBonus: state => state.xbbBonus
    })
  },
  mounted () {
    this.init()
    this.hijackPlaying()
    this.hijackPasue()
  },
  beforeDestroy () {
    let stopEvent = 'STOP'
    if (this.playEvent === 'ADSTART') stopEvent = 'ADSTOP'
    this.sendWebSocket(stopEvent)
    this.ws.close()
  },
  methods: {
    init () {
      const { domain, userid, cid, wsUrl, ad } = this.xbbBonus
      this.adVersion = ad
      this.ws = new ReconnectingWebSocket(`${wsUrl}?domain=${domain}&userid=${userid}&cid=${cid}`, [], {
        maxRetries: 10, // maximum number of retries
        maxReconnectionDelay: 3000,
        minReconnectionDelay: 3000
      })

      this.ws.onopen = (event) => {
        console.log('ws onopen')
        this.firstGetStatus = true
      }

      this.ws.onclose = (event) => {
        console.log('ws close reason:', event.reason)
        if (event.reason === 'NO ACTIVITY') return this.closeWs()
        this.progressData.timer = false
        this.progressData.progress = 0
        this.progressData.status = 'RECONNECT'
      }

      this.ws.onmessage = (event) => {
        const data = JSON.parse(event.data)
        this.socketId = data.SocketId

        switch (data.Status) {
          case 'OPEN':
            this.intoPageAd()
            this.progressData.status = 'PLAY'
            this.bonusStatus = data.Status
            if (!this.player.paused()) {
              this.sendWebSocket('PLAY')
            }
            break
          case 'FULL':
            this.intoPageAd()
            this.bonusStatus = data.Status
            this.progressHandler(data, { timer: false, status: 'CLOSE' })
            if (this.adVersion && this.playEvent !== 'ADSTART' && !this.player.paused()) {
              this.playEvent = 'ADSTART'
              this.sendWebSocket('ADSTART')
            }
            break
          case 'PLAY':
            this.progressHandler(data, { timer: true, status: 'PLAY' })
            break
          case 'STOP':
            this.bonusData = data
            this.progressData.timer = false
            this.progressData.progress = 0
            break
          case 'WAIT':
            this.waitType(data)
            break
          case 'BREAK':
          case 'BREAK_WAIT':
            this.progressHandler(data, { timer: false, status: 'PLAY' })
            if (this.player.isFullscreen() && isIOS) this.player.exitFullscreen()
            this.player.pause()
            this.dialog = {
              visible: true,
              component: 'BonusDialogBreak'
            }
            break
          case 'AD':
            this.bonusData = data
            this.progressData.timer = false
            this.progressData.progress = 0
            if (this.player.isFullscreen() && isIOS) this.player.exitFullscreen()
            this.player.pause()
            this.dialog = {
              visible: true,
              component: 'BonusDialogAd'
            }
            break
          case 'ADSTART':
            if (this.firstAdWait) {
              this.waitType(data)
              this.firstAdWait = false
            }
            break
          case 'NOACTIVE':
            this.closeWs()
            break
        }

        if (this.firstGetStatus) this.firstGetStatus = false
      }
    },
    handleBonusTimer () {
      this.progressData.progress = (this.progressData.progress + 1) % 60
    },
    openDialog () {
      this.player.pause()
      this.dialog = {
        visible: true,
        component: this.bonusStatus === 'FULL' ? 'BonusDialogFull' : 'BonusDialogWait'
      }
    },
    closeDialog (type) {
      this.dialog.visible = false
      if (type === 'AD') this.continueWatch = false
    },
    handleContinueWatch (type) {
      this.dialog.visible = false
      if (type === 'WAIT') this.continueWatch = true
      if (type === 'BREAK_WAIT') this.waitType(this.bonusData)
      if (type !== 'BREAK_WAIT') this.player.play()
    },
    /**
     * data => socket 回傳資料
     * {
     *  timer: 是否繼續倒數
     *  status: BonusProgress Component Status
     * }
     */
    progressHandler (data, { timer, status }) {
      // 判斷 amount 是否不同，得知是否達成 1min
      let progressStatus = status
      if (typeof this.bonusData.Amount !== 'undefined' && this.bonusData.Amount !== data.Amount) {
        progressStatus = 'COMPLETE'
      }
      this.bonusData = data
      this.progressData = {
        status: progressStatus,
        progress: data.SyncSeconds,
        timer,
        times: data.CueTimes,
        amount: Number(data.Active.MinAmout).toFixed(2)
      }

      if (progressStatus === 'COMPLETE') {
        setTimeout(() => {
          this.progressData.status = status
        }, 2000)
      }
    },
    sendWebSocket (type) {
      if (this.ws && this.socketId !== null) {
        this.ws.send(JSON.stringify({
          SocketId: this.socketId,
          Type: type,
          SendTime: new Date().toISOString()
        }))
      }
    },
    intoPageAd () {
      if (this.adVersion && this.firstAd) {
        this.sendWebSocket('AD')
        this.firstAd = false
      }
    },
    waitType (data) {
      let status = 'CLOSE'
      this.intoPageAd()
      this.bonusStatus = data.Status
      if (data.Mession && data.Mession.ActionType === missionType.finish) {
        status = 'NEXT'
      }

      this.progressHandler(data, { timer: false, status })
      if (this.firstGetStatus) {
        if (this.triggerOnceAdWait) {
          this.firstAdWait = true
          this.triggerOnceAdWait = false
        }
        return
      }

      // 點擊繼續觀看，再次播放不會跳出彈窗
      if (!this.continueWatch) {
        if (this.player.isFullscreen() && isIOS) this.player.exitFullscreen()
        this.player.pause()
        this.dialog = {
          visible: true,
          component: 'BonusDialogWait'
        }
      }
      this.continueWatch = false
    },
    // 劫持playing函數, 使事件能夠解耦
    hijackPlaying () {
      const parentPlaying = this.playingEvent
      this.$emit('update:playing-event', () => {
        parentPlaying()

        let playEvent = 'PLAY'
        if (this.adVersion && ['WAIT', 'FULL', 'BREAK_WAIT', 'ADSTART'].includes(this.bonusStatus)) playEvent = 'ADSTART'
        this.playEvent = playEvent
        this.sendWebSocket(playEvent)
      })
    },
    hijackPasue () {
      const parentPause = this.pauseEvent
      this.$emit('update:pause-event', () => {
        parentPause()
        let stopEvent = 'STOP'
        if (this.adVersion) {
          if (!this.firstAd && this.playEvent) {
            if (this.playEvent === 'ADSTART') stopEvent = 'ADSTOP'
            this.sendWebSocket(stopEvent)
          }
        } else {
          this.sendWebSocket(stopEvent)
        }
      })
    },
    closeWs () {
      this.$emit('update:isDestroy', true)
    }
  }
}
</script>

<style scoped>
.xbb_progress {
  position: absolute;
  top: 25%;
  right: 0;
}

.xbb_dialog {
  padding: 24px;
  background: rgba(0, 0, 0, 0.4);
}

.fullscreen {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 6000;
  max-width: 100vw;
  max-height: 100vh;
  padding-top: 75px;
  overflow: auto;
  border-radius: 0 !important;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.items-center {
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/views/xbb/Index.vue